import { useAuth } from "hooks/useAuth";
import { Link } from "react-router-dom";
import { AdminList } from "types/User";

export function OptionRotateSupport() {
    const { user } = useAuth();

    if (user == null || !AdminList.includes(user.name)) {
        return (
            <div></div>
        );
    } else {
        return (
            <tr>
                <td>Gerenciar rodízio do suporte</td>
                <td><Link to={"/suporte"} >Acessar</Link></td>
            </tr>
        );
    }
}